import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Language } from '@models/profile/language';

@Component({
  selector: 'profile-languages',
  templateUrl: './languages.component.html',
  styleUrls: ['./languages.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguagesComponent implements OnChanges {
  @Input() model: Language[];
  @Input() loading: boolean;

  loadingItem: Language;
  language = new Language();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.loading && !changes.loading.currentValue) {
      this.language = new Language();
    }
  }

  trackById(_: any, item: Language): string {
    return item.name;
  }
}
